module.exports = __webpack_public_path__ + "img/pluto116.45b73dc6.jpg";